import { useIonRouter, IonText, IonIcon, IonSelect, IonSelectOption, IonTextarea, useIonViewWillEnter, IonGrid, IonCol, IonRow, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Clipboard } from '@capacitor/clipboard';
import { clipboardOutline } from 'ionicons/icons';

import { showAlert, showConfirm } from '../components/Alert';
import NServer, { UIElement } from "../components/NServer";
import Vault from '../components/Vault';
import { LANGUAGE, GetStr } from "../language/Language";
import { CategoryData } from "../data/category";

import './Main.css'; 

interface NewChannelProp extends RouteComponentProps<{
    id : any
    }> 
{}

const NewChannel : React.FC<NewChannelProp> = ({match}) => {

    //	Initializing our router
	const router = useIonRouter();

    const [title, setTitle] = useState("");
    const [desc, setDesc] = useState("");
    const [category, setCategory] = useState("unknown");
    const [categories, setCategories] = useState<CategoryData[]>([]);

    useIonViewWillEnter(() => {
        getData();        
    });

    // reload the data
    const getData = async () => {
        // upload the content
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            channel: match.params.id
        }

        var server = new NServer();
        await server.getList("nc_channel", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            return;
        }

        setTitle(server.data.title);
        setDesc(server.data.desc);
        setCategories(server.data.categories);
        setCategory(server.data.category);
    }

    // create the channel
    const createChannel = async () => {
        // upload the content
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            channel: match.params.id,
            title: title,
            desc: desc,
            category: category
        }

        var server = new NServer();
        await server.sendForm("nc_edit_channel", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            return;
        }

        // success
        router.push("/studio", "back", "pop");
    }

    // Paste from clipboard
    const pasteTitle = async () => {
        const { type, value } = await Clipboard.read();
        setTitle(value);
    };

    const pasteDesc = async () => {
        const { type, value } = await Clipboard.read();
        setDesc(value);
    };

    return (
        <IonPage>
            <IonHeader>
                <IonItem></IonItem>
            </IonHeader>
            <IonContent>
                <div id="border-bk" />
                <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol className="ion-text-left ion-padding" size-md="8" size-lg="6" size-xl="4" size="12">
                            <div><IonText><h4>{ GetStr(match.params.id < 0 ? LANGUAGE.TXT_NC_CAP : LANGUAGE.TXT_NC_EDIT_CAP) }</h4></IonText></div>
                            {
                                match.params.id < 0 ?
                            <div>
                                <IonText>{ GetStr(LANGUAGE.TXT_NC_ABOUT) }</IonText>
                                <br/>
                            </div>
                                :
                            <div/>
                            }
                            <IonItem>
                                <IonLabel position="floating">{ GetStr(LANGUAGE.TXT_NC_NAME) }</IonLabel>
                                <IonInput value={title} onIonChange={ (e)=> { setTitle(e.detail.value!)} }></IonInput>
                                <IonIcon icon={clipboardOutline} slot="end" onClick={pasteTitle} />
                            </IonItem>
                            <IonItem className="ion-margin-top">
                                <IonLabel position="floating">{ GetStr(LANGUAGE.TXT_NC_DESC) }</IonLabel>
                                <IonTextarea value={desc} rows={3} auto-grow maxlength={300} onIonChange={e => setDesc(e.detail.value!)}></IonTextarea>
                                <IonIcon icon={clipboardOutline} slot="end" onClick={pasteDesc} />
                            </IonItem>
                            <IonItem className="ion-margin-top">
                                <IonLabel position="floating">{ GetStr(LANGUAGE.TXT_NC_CATEGORY) }</IonLabel>
                                <IonSelect value={category} interface="action-sheet" onIonChange={e => setCategory(e.detail.value!)}>
                                    { categories.map( m => 
                                    <IonSelectOption key={m.id} value={m.value}>{m.name}</IonSelectOption>
                                    )} 
                                </IonSelect>
                            </IonItem>
                            <br/>
                            <IonButton className="main-but ion-margin-top" color="primary" expand="block" onClick={createChannel}>
                                { GetStr(match.params.id < 0 ? LANGUAGE.TXT_NC_CREATE : LANGUAGE.TXT_NC_SAVE) }
                            </IonButton>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
};

export default NewChannel;